import React from 'react';
import Skeleton from '@/components/ui/Skeleton';

// AIDEV-NOTE: aria-busy sits on the cell rather than the table so a screen reader reports "loading"
// at the point the user navigates to that cell — a table-level flag can't say which scores are
// still outstanding, and the per-slideshow queries aren't visible to any single aggregate anyway.
// AIDEV-NOTE: the default gray-200 + animate-pulse read as an empty cell at this size (PLAT-18059 review),
// hence the darker fill and deeper skeleton-pulse.
const GradeCellSkeleton = () => (
  <div
    aria-busy
    className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-full"
    data-testid="grade-cell-skeleton"
  >
    <span className="sr-only">Loading score</span>
    <div aria-hidden>
      <Skeleton bgColor="tw-bg-gray-300" className="tw-animate-skeleton-pulse" height="tw-h-4" width="tw-w-14" />
    </div>
  </div>
);

export default GradeCellSkeleton;
